import React, { useEffect, useState } from 'react'
import { useMealDealsSelectionCount } from './use-meal-deals-selection-count'
import { Box, Button, Flex, Stack, Text } from '../../vanilla'
import { ProductTileRegular } from '../../components/product-tile-regular'
import { observer } from 'mobx-react-lite'
import { useProductStore } from '../../store/hooks/useStore'

interface MealDealItemProps {
  index: number
  label: string
  req: string
  productsIds: string[]
  setCompleteness: (complete: boolean) => void
}

const ITEMS_IN_ROW = 5

const MealDealItemContainer: React.FC<MealDealItemProps> = ({
  index,
  label,
  req: reqProp,
  productsIds,
  setCompleteness,
}) => {
  const productStore = useProductStore()
  const { productsById } = productStore;
  const req = parseInt(reqProp, 10);
  const [itemsToShowCount, setItemsToShowCount] = useState(ITEMS_IN_ROW)
  const number = index + 1
  const selection = useMealDealsSelectionCount(productsIds)

  useEffect(() => {
    setCompleteness(selection >= req)
  }, [selection, req])

  const filteredProductsIds = productsIds.filter((id) => productsById[id]);
  return (
    <Box id={`step-${number}`}>
      <Stack gap="24px">
        <Flex gap="8px" justifyContent="center" alignItems="center">
          <Flex
            alignItems="center"
            justifyItems="center"
            justifyContent="center"
            bg={selection >= req ? 'accent1' : 'accent3'}
            padding="8px"
            style={{ borderRadius: '100%', height: '65px', minWidth: '65px' }}
          >
            <Text color="white" textAlign="center" variant="heading5">
              {number}
            </Text>
          </Flex>
          <Stack gap="4px">
            <Box>
              <Text variant="heading5">
                Choose {req} {label}
              </Text>
            </Box>
            <Box>
              <Text variant="text3" color="gray400" lineHeight="none">
                {selection} of {req}{' '}
                {selection === 0
                  ? 'Add one to start'
                  : selection < req
                  ? 'Added'
                  : 'Well done, step completed!'}
              </Text>
            </Box>
          </Stack>
        </Flex>
        <Box 
          display ='grid'
          gridTemplateColumns={['1x','5x']}
          gap = '16px'
          justifyContent={'center'}
        >
          {filteredProductsIds.slice(0, itemsToShowCount).map((id) => {
            return <ProductTileRegular productId={id} key={id} hideOffer />
          })}
        </Box>
        {filteredProductsIds?.length > itemsToShowCount ? (
          <Flex justifyContent="center">
            <Button
              variant="outlineDark"
              onClick={() => {
                if (itemsToShowCount < productsIds.length) {
                  setItemsToShowCount(itemsToShowCount + ITEMS_IN_ROW)
                }
              }}
            >
              Show More {label}
            </Button>
          </Flex>
        ) : null}
      </Stack>
    </Box>
  );
};

export const MealDealItem = observer(MealDealItemContainer);